import adminApiRequests from 'pages/adminApiRequests'

export default [
  { path: '/admin-api-requests', name: 'adminApiRequests', component: adminApiRequests},
]
